unable to read source [project]/node_modules/src/core.ts